import React from 'react';
import { FaCheckCircle, FaInfoCircle } from 'react-icons/fa';
import ReactQuill, { Quill } from 'react-quill';
import ReactDOM from 'react-dom';

// Create custom Blot for icons
const IconBlot = Quill.import('blots/embed');

class TickBlot extends IconBlot {
  static create(value) {
    const node = super.create();
    const tickIcon = document.createElement('span');
    ReactDOM.render(<FaCheckCircle size={16} color="#2A77A7" />, tickIcon);
    node.appendChild(tickIcon);
    return node;
  }

  static value(node) {
    return 'tick';
  }
}
TickBlot.blotName = 'tick';
TickBlot.tagName = 'span';
TickBlot.className = 'editor-tick-icon';

class InfoBlot extends IconBlot {
  static create(value) {
    const node = super.create();
    const infoIcon = document.createElement('span');
    ReactDOM.render(<FaInfoCircle size={16} color="#DDC77C" />, infoIcon);
    node.appendChild(infoIcon);
    return node;
  }

  static value(node) {
    return 'info';
  }
}
InfoBlot.blotName = 'info';
InfoBlot.tagName = 'span';
InfoBlot.className = 'editor-info-icon';

// Register the custom Blots
Quill.register(TickBlot);
Quill.register(InfoBlot);

// Import and register the size format
const Size = Quill.import('attributors/style/size');
// Define your sizes
Size.whitelist = [
  '8px', '9px', '10px', '11px', '12px', '14px', '16px',
  '18px', '24px', '30px', '36px', '48px', '60px', '72px', '96px'
];
Quill.register(Size, true);

// Custom toolbar options for Quill
export const modules = {
  toolbar: {
    container: [
      ['bold', 'italic', 'underline'],
      // [{ 'font': ['Neue Haas Unica Pro'] }],
      [{
        'size': Size.whitelist  // Use the whitelist we defined
      }],
      ['tick', 'info'], // Custom buttons
    ],
    handlers: {
      tick: function(value) {
        const range = this.quill.getSelection(true);
        this.quill.insertEmbed(range.index, 'tick', true, 'user');
        this.quill.setSelection(range.index + 1);
      },
      info: function(value) {
        const range = this.quill.getSelection(true);
        this.quill.insertEmbed(range.index, 'info', true, 'user');
        this.quill.setSelection(range.index + 1);
      }
    }
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true
  }
};

// Custom formats
export const formats = [
  'bold', 'italic', 'underline',
  'font',
  'size',  // Make sure size is included
  'tick', 'info'  // Add our custom formats
];

// Create React elements for the icons
const TickIcon = () => <FaCheckCircle size={18} color="#2A77A7" />;
const InfoIcon = () => <FaInfoCircle size={18} color="#DDC77C" />;

// Register custom button icons using React components
const icons = Quill.import('ui/icons');
const tickContainer = document.createElement('span');
const infoContainer = document.createElement('span');

ReactDOM.render(<TickIcon />, tickContainer);
ReactDOM.render(<InfoIcon />, infoContainer);

icons['tick'] = tickContainer.innerHTML;
icons['info'] = infoContainer.innerHTML;

// export const toolbarOptions = {
//   options: ['inline', 'fontSize', 'fontFamily', 'history'],
//   inline: {
//     inDropdown: false,
//     className: undefined,
//     component: undefined,
//     dropdownClassName: undefined,
//     options: ['bold', 'italic', 'underline'],
//   },

//   fontSize: {
//     // icon: fontSize,
//     options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
//     className: undefined,
//     component: undefined,
//     dropdownClassName: undefined,
//   },
//   fontFamily: {
//     options: ['Neue Haas Unica Pro'],
//     className: undefined,
//     component: undefined,
//     dropdownClassName: undefined,
//     defaultFontFamily: 'Neue Haas Unica Pro',
//   },
//   list: {
//     inDropdown: false,
//     className: undefined,
//     component: undefined,
//     dropdownClassName: undefined,
//     options: ['unordered', 'ordered', 'indent', 'outdent'],
//   }
// }


// export const CustomToolbarOption = ({ editorState, onChange }) => {
//   const addTick = () => {
//     const contentState = Modifier.replaceText(
//       editorState.getCurrentContent(),
//       editorState.getSelection(),
//       "✓",
//       editorState.getCurrentInlineStyle()
//     );
//     onChange(EditorState.push(editorState, contentState, "insert-characters"));
//   };

//   const addInfo = () => {
//       const contentState = Modifier.replaceText(
//         editorState.getCurrentContent(),
//         editorState.getSelection(),
//         "ℹ",
//         editorState.getCurrentInlineStyle()
//       );
//       onChange(EditorState.push(editorState, contentState, "insert-characters"));
//     };

//   return(
//       <div style={{ display: 'flex', gap: '8px', padding: '8px 0px' }}>
//           <FaCheckCircle size={20} color="#2A77A7" style={{ cursor: 'pointer' }} onClick={addTick} />
//           <FaInfoCircle size={20} color="#DDC77C" style={{ cursor: 'pointer' }} onClick={addInfo} />
//       </div>
//   )
// };